import React from 'react';
import { SearchContext } from '../common/SearchContext.js';

/**
 * Returns data about essentials if this is an essentials-only search,
 * otherwise returns project data.
 * It pulls the essentials data from SearchContext.
 * @param projectsData The project search data returned by our API
 */
export default (projectsData) => {
    const { essentialsData, isEssentialsListsEnabled, essentialsOnly } = React.useContext(SearchContext);

    let mainData, resultList;
    let totalHits;

    if (isEssentialsListsEnabled && essentialsOnly) {
        mainData = essentialsData;
        const { essentialsLists, totalResults } = essentialsData;
        resultList = essentialsLists;
        totalHits = totalResults;
    } else {
        mainData = projectsData;
        const { proposals, totalProposals } = projectsData;
        resultList = proposals;
        totalHits = totalProposals;
    }

    const { breadcrumb, expandedLocationMessage, searchVOHashCode, expandedLocationData } = mainData;

    const results = {
        breadcrumb,
        essentialsOnly,
        searchVOHashCode,
        resultList: resultList || [],
        totalResults: totalHits || 0,
        expandedLocationData,
    };

    if (resultList && resultList.length > 0) {
        results.expandedLocationMessage = expandedLocationMessage;
    }

    return results;
};
